import { isValidLocaleFormat, convertUrlToArray } from './helpers';
// MLP Lang Region Redirector

/*
 * @description Crawler User Agents List
 */
export const crawlerUserAgents = [
    'adidxbot',
    'adsbot-google',
    'baiduspider',
    'bingbot',
    'facebookexternalhit/1.1',
    'googlebot',
    'ia_archiver',
    'optimizelyedit',
    'twitterbot',
    'slurp'
];

/* Local storage wrapper */
export function localStorageSetItem(key, value) {
    try {
        window.localStorage.setItem(key, value);
    } catch (e) {}
}
export function localStorageGetItem(key) {
    try {
        return window.localStorage.getItem(key);
    } catch (e) {
        return null;
    }
}
export function localStorageRemoveItem(key) {
    try {
        localStorage.removeItem(key);
    } catch (e) {}
}


/**
 * @description Replace the current language string with a new one
 * @param {string} pathname
 * @param {string} newLang
 * @return {string}
 */
export function replaceLanguageInPathname(pathname, newLang) {
    let parts = convertUrlToArray(pathname);

    if (parts.length && isValidLocaleFormat(parts[0])) {
        // Valid lang found in url
        // Subtract the lang
        parts.shift();
    }

    if (newLang !== 'en' && newLang !== 'en-us') {
        // Add newLang to parts
        parts.unshift(newLang);
    }

    let newLangRegionAndPath = parts.join('/');

    // Only add prefix slash if path is not empty
    if (newLangRegionAndPath) {
        newLangRegionAndPath = '/' + newLangRegionAndPath;
    }

    return newLangRegionAndPath;
}


/**
 * @description Retrieves the user's primary browser language.
 * If the language is a lang-region string only return the lang.
 */
export function getBrowserLanguage() {
    const browserLanguage = (
        window.navigator.languages && window.navigator.languages[0]
        || window.navigator.language
        || window.navigator.userLanguage
        || '')
        .toLowerCase();

    return browserLanguage.split('-')[0];
}


/**
 * @description Simple includes helper for older browser support
 */
export function isInArray(arr, arg) {
    if (arr && arg) {
        return arr.indexOf(arg) > -1;
    }

    return false;
}


/**
 * @description Checks userAgent to see if it is a supported crawler bot.
 * @return {Boolean} Whether the userAgent has been verified as a crawler bot.
 */
export function getCrawlerBot() {
    if (window.navigator && window.navigator.userAgent) {
        const userAgent = window.navigator.userAgent.toLowerCase();
        const isBot = crawlerUserAgents.some(function (bot) {
            return isInArray(userAgent, bot);
        });

        return isBot;
    }

    return false;
}


/**
 * @description Sets localStorage entry with TTL
 * @param {String} key - Your local storage key
 * @param {String} value - Your local storage value
 * @param {String} ttl - Time to live expiration in milliseconds. Default 1 day
 */
export function localStoreSetItem(key, value, ttl = 1000 * 60 * 60 * 24) {
    const now = new Date().getTime();
    const item = {
        value,
        ttl: now + ttl
    };
    localStorageSetItem(key, JSON.stringify(item));
}


/**
 * @description Get localStorage entry if it has not expired. If expired remove it.
 * @param {String} key - Your local storage key
 * @return {String} Returns your string value
 */
export function localStoreGetItem(key) {
    const itemStr = localStorageGetItem(key);
    let item;
    const now = new Date();

    if (!itemStr) {
        return null;
    }

    try {
        item = JSON.parse(itemStr);
    } catch (e) {
        return null;
    }

    if (now.getTime() > item.ttl) {
        localStorageRemoveItem(key);
        return null;
    }

    return item.value;
}


export function getLangOverride(regionConfig) {
    let regionLanguages = regionConfig.regionLanguages;
    const regionCode = regionConfig.regionCode;
    const rootLangs = ['en', 'en-us'];
    let langOverride;


    // Force Lowercase all region languages for accurate comparison
    regionLanguages = regionLanguages.map(function (v) {
        return v.toLowerCase();
    });

    // Get Preferred Lang MLP LocalStorage
    let languagePreferenceMlp = localStorageGetItem('languagePreferenceMlp') || '';
    if (languagePreferenceMlp) {
        languagePreferenceMlp = languagePreferenceMlp.toLowerCase();
    }

    // Get Browser Language and Browser Lang Region
    const browserLanguage = getBrowserLanguage();
    let browserLangRegion = null;
    if (browserLanguage) {
        browserLangRegion = browserLanguage + '-' + regionCode.toLowerCase();
    }

    // Get Valid urlLang
    const splitUrl = window.location.pathname.split('/');
    const reqUrlPrefix = splitUrl[1];
    let urlLang = 'en';
    if (isValidLocaleFormat(reqUrlPrefix)) {
        urlLang = reqUrlPrefix.toLowerCase();
    }

    // Set defaultLang
    let defaultLang;
    if (regionConfig.lang) {
        defaultLang = regionConfig.lang.toLowerCase();
    }

    if (rootLangs.includes(urlLang)) {
        // Check to see if User came to domain.com/welcome/xxx
        if (languagePreferenceMlp && isInArray(regionLanguages, languagePreferenceMlp)) {

            // Check to see if languagePreferenceMlp is set and valid for the current region
            langOverride = (!rootLangs.includes(languagePreferenceMlp)) ? languagePreferenceMlp : false;
            console.info('Lang: 1 - languagePreferenceMlp is valid Goto languagePreferenceMlp', langOverride);

        } else if (browserLangRegion && !rootLangs.includes(browserLangRegion) &&
            isInArray(regionLanguages, browserLangRegion)) {

            // If no preferred Lang set, check the Browser Language
            langOverride = browserLangRegion;
            console.info('Lang: 2 - Goto browserLangRegion', langOverride);

        } else if (!rootLangs.includes(defaultLang)) {

            // If no preferred lang and the browser lang is not valid,
            // use the region default (if the default is not EN)
            langOverride = defaultLang;
            console.info('Lang: 3 - Invalid langRegion Goto defaultLang', langOverride);

        }

    } else if (!isInArray(regionLanguages, urlLang)) {

        if (browserLangRegion && browserLangRegion !== urlLang &&
            isInArray(regionLanguages, browserLangRegion)) {

            // If the specified urlLang is not valid for the region try the browser language
            langOverride = browserLangRegion;
            console.info('Lang: 4 urlLang Invalid for Region Goto browserLangRegion', langOverride);

        } else {

            // If the specified urlLang and the browser lang are invalid for region, use the region default.
            langOverride = defaultLang;
            console.info('Lang: 5 - Invalid langRegion Goto defaultLang', langOverride);

        }

    }

    return langOverride;
}


/**
 * If the user enters a URL with a language-region string that does not match there current location it will redirect
 * the user to the same url but for the default language for the correct region.
 * @example /welcome will redirect to /en-ca/welcome
 */
export function redirectForRegionLang() {
    const regionConfig = window.dssMlpConfigs.regionConfig;
    const regionCode = regionConfig.regionCode;
    const sessionRegionCode = localStoreGetItem('regionCodeMLP') || regionCode;
    const regionLanguages = regionConfig.regionLanguages;

    // Don't redirect for bots or preview environment
    let bypassRedirect;
    if (getCrawlerBot() || window.dssMlpConfigs && window.dssMlpConfigs.bypassRedirect) {
        bypassRedirect = true;
    }

    // Don't redirect loop as we have already redirected the guest
    if (sessionRegionCode !== regionCode) {
        bypassRedirect = true;
        console.info('Lang: Missmatch SessionRegion', sessionRegionCode, '- ServerRegion', regionCode);
    }

    if (!bypassRedirect && regionLanguages && regionLanguages.length) {

        const langOverride = getLangOverride(regionConfig);

        if (langOverride) {
            const origin = window.location.origin;
            const search = window.location.search;
            let pathname = window.location.pathname;
            pathname = replaceLanguageInPathname(pathname, langOverride);
            const redirectUrl = origin + pathname + search;

            localStoreSetItem('regionCodeMLP', regionCode, 5000);
            console.info('Lang: 6a - REDIRECT ', redirectUrl);
            window.location.replace(redirectUrl);

        } else {
            // Language specified in the Url is a valid langRegion, do nothing.
            console.info('Lang: 6b - urlLang is valid langRegion Stay', window.location.pathname);
        }

    }
}


/**
 * If the guest is logged in and this is an olp type page, redirect them to /home
 */
export function redirectForIsLoggedIn() {
    const isLoggedIn = localStorageGetItem('isLoggedIn');
    const { isLoggedInRedirect } = window.dssMlpConfigs;
    let redirectHome = false;

    if (isLoggedInRedirect && isLoggedIn) {
        redirectHome = true;
        window.location.replace('/home');
    }

    return redirectHome;
}


/**
 * Auth Lang Region Redirect
 */
export function authLangRegionInit() {
    console.info('Lang: Lang Region Init');

    if (!redirectForIsLoggedIn()) {
        redirectForRegionLang();
    }
}
